export class Account {
    id = -1;
    number = '';
    originalName = '';
    name = '';

    deserialize(data: any) {
        this.id = data.id ?? -1;
        this.number = data.original_number ?? data.number_without_suffix ?? data.number ?? '';
        this.originalName = data.name ?? '';
        this.name = this.number && this.originalName ? `(${this.number}) ${this.originalName}` : this.originalName || this.number;
        return this;
    }

    static Sort(a1: Account, a2: Account) {
        return a1.name.localeCompare(a2.name);
    }
}
